var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#b)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "url(#c)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M190 129a8 8 0 0 1 8-8h115.999a8 8 0 0 1 8.001 8v7.333a8 8 0 0 1-8 8h-4.651v53.333h-53.333v-53.333h-.011v53.333h-53.333v-53.333H198a8 8 0 0 1-8-8V129Zm0 246.667a8 8 0 0 1 8-8h4.651v-53.333h.021v-.001l.006-.002c.001-26.733 19.671-48.871 45.327-52.734v-11.193c-25.66-3.86-45.333-26.001-45.333-52.737h106.646c0 26.736-19.674 48.877-45.334 52.737v11.186c25.676 3.846 45.366 25.995 45.366 52.742l-.006-.002v.004c0 .569-.009 1.137-.026 1.702v51.63h-53.091l-.158.001h57.93a8 8 0 0 1 8.001 8V383a8 8 0 0 1-8 8H198a8 8 0 0 1-8-8v-7.333Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M163.293 129a8 8 0 0 1 8-8h170.944a8.001 8.001 0 0 1 8.001 8v7.333a8 8 0 0 1-8 8H171.294a8 8 0 0 1-8.001-8V129Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M163.293 375.667a8 8 0 0 1 8-8h170.944a8 8 0 0 1 8.001 8V383a8 8 0 0 1-8 8H171.294a8.001 8.001 0 0 1-8.001-8v-7.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M256.776 144.333h-75.534v53.333h75.534v-53.333ZM256.783 261c-41.716 0-75.534 23.878-75.534 53.334 0 29.455 33.818 53.333 75.534 53.333 41.716 0 75.533-23.878 75.533-53.333 0-29.456-33.817-53.334-75.533-53.334Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A4F4",
    d: "M256.746 367.667h-75.534v-53.333h75.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M332.323 144.333h-75.534v53.333h75.534v-53.333Zm-75.528 116.666 11.33 37.333 64.203 16c0-29.455-33.817-53.333-75.533-53.333Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M256.772 197.667v169.999h-75.534v-53.333l64.204-16v-47.929c-36.341-3.86-64.204-26.001-64.204-52.737h75.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M332.28 197.667c0 26.736-27.863 48.877-64.204 52.737v47.929l64.204 16v53.333h-75.534V197.667h75.534Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    x2: 256,
    y1: 0,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 190,
    x2: 322,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 163.293,
    x2: 350.238,
    y1: 132.667,
    y2: 132.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 163.293,
    x2: 350.238,
    y1: 379.333,
    y2: 379.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 213.818,
    x2: 215.936,
    y1: 304,
    y2: 144.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 269.536,
    x2: 268.83,
    y1: 144.333,
    y2: 297.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 181.238,
    x2: 256.772,
    y1: 282.667,
    y2: 282.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 256.746,
    x2: 332.28,
    y1: 282.667,
    y2: 282.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 0 256) scale(226)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 196,
    height: 334,
    x: 158,
    y: 89,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1280_2902",
    stdDeviation: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonded);
export default __webpack_public_path__ + "static/media/bonded.bdf452cdd45e74b598e1c8bef4c513c2.svg";
export { ForwardRef as ReactComponent };